import React from "react";
import {
  STATUT_SORTIE,
  STATUT_INSCRIPTION,
  STATUT_PAIEMENT,
  STATUT_FORMATION,
  STATUT_ECHEANCIER,
  STATUT_ECHEANCE,
} from "../../utils/constants";

// Configuration complète des statuts (sans icônes)
const statusConfig = {
  // Statuts des sorties
  [STATUT_SORTIE.PLANIFIEE]: {
    color: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
    border: "border-blue-200 dark:border-blue-800/30",
    label: STATUT_SORTIE.PLANIFIEE,
  },
  [STATUT_SORTIE.EN_COURS]: {
    color:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
    border: "border-green-200 dark:border-green-800/30",
    label: STATUT_SORTIE.EN_COURS,
  },
  [STATUT_SORTIE.TERMINEE]: {
    color: "bg-gray-100 text-gray-700 dark:bg-gray-700/50 dark:text-gray-400",
    border: "border-gray-200 dark:border-gray-600",
    label: STATUT_SORTIE.TERMINEE,
  },
  [STATUT_SORTIE.ANNULEE]: {
    color: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    border: "border-red-200 dark:border-red-800/30",
    label: STATUT_SORTIE.ANNULEE,
  },

  // Statuts des inscriptions
  [STATUT_INSCRIPTION.EN_ATTENTE]: {
    color:
      "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400",
    border: "border-yellow-200 dark:border-yellow-800/30",
    label: STATUT_INSCRIPTION.EN_ATTENTE,
  },
  [STATUT_INSCRIPTION.CONFIRMEE]: {
    color:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
    border: "border-green-200 dark:border-green-800/30",
    label: STATUT_INSCRIPTION.CONFIRMEE,
  },
  [STATUT_INSCRIPTION.LISTE_ATTENTE]: {
    color: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
    border: "border-blue-200 dark:border-blue-800/30",
    label: STATUT_INSCRIPTION.LISTE_ATTENTE,
  },

  // Statuts des adhérents
  Actif: {
    color:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
    border: "border-green-200 dark:border-green-800/30",
    label: "Actif",
  },
  Inactif: {
    color: "bg-gray-100 text-gray-700 dark:bg-gray-700/50 dark:text-gray-400",
    border: "border-gray-200 dark:border-gray-600",
    label: "Inactif",
  },
  Suspendu: {
    color:
      "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
    border: "border-orange-200 dark:border-orange-800/30",
    label: "Suspendu",
  },
  "En formation": {
    color: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
    border: "border-blue-200 dark:border-blue-800/30",
    label: "En formation",
  },
  Ancien: {
    color: "bg-slate-100 text-slate-700 dark:bg-slate-700/50 dark:text-slate-400",
    border: "border-slate-200 dark:border-slate-600",
    label: "Ancien",
  },

  // Statuts des paiements
  [STATUT_PAIEMENT.PAYE]: {
    color:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
    border: "border-green-200 dark:border-green-800/30",
    label: STATUT_PAIEMENT.PAYE,
  },
  [STATUT_PAIEMENT.PARTIEL]: {
    color:
      "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400",
    border: "border-yellow-200 dark:border-yellow-800/30",
    label: STATUT_PAIEMENT.PARTIEL,
  },
  Remboursé: {
    color:
      "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
    border: "border-purple-200 dark:border-purple-800/30",
    label: "Remboursé",
  },

  // Circuit de validation des adhésions soumises par l'adhérent
  // (licence FFESM / assurances — voir AdhesionForm/AdhesionList).
  // "En attente" réutilise déjà STATUT_INSCRIPTION.EN_ATTENTE ci-dessus.
  Validé: {
    color:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
    border: "border-green-200 dark:border-green-800/30",
    label: "Validé",
  },
  Rejeté: {
    color: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    border: "border-red-200 dark:border-red-800/30",
    label: "Rejeté",
  },

  // Statuts d'expiration (certificats médicaux + adhésions, dérivé de la
  // date de fin/validité — voir CertificatMedical.statut / Adhesion.statut).
  // Étiqueté "À jour" plutôt que "Valide" : sur les mêmes fiches s'affiche
  // aussi le statut de validation du dossier ("Validé"/"En attente"/
  // "Rejeté", voir plus bas) — "Valide" et "Validé" ne se distinguent qu'à
  // l'accent près et se sont révélés source de confusion pour les
  // utilisateurs quand les deux apparaissent sur le même écran. Couleur
  // volontairement différente de "Validé" (cyan vs vert) pour que la
  // distinction se voie aussi sans lire le texte.
  Expiré: {
    color: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    border: "border-red-200 dark:border-red-800/30",
    label: "Expiré",
  },
  Valide: {
    color: "bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400",
    border: "border-cyan-200 dark:border-cyan-800/30",
    label: "À jour",
  },

  // Statuts de l'échéancier ("En attente"/"En cours"/"Annulée" déjà
  // couverts ci-dessus par d'autres domaines, mêmes couleurs)
  [STATUT_ECHEANCE.PAYEE]: {
    color:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
    border: "border-green-200 dark:border-green-800/30",
    label: STATUT_ECHEANCE.PAYEE,
  },
  [STATUT_ECHEANCE.EN_RETARD]: {
    color: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    border: "border-red-200 dark:border-red-800/30",
    label: STATUT_ECHEANCE.EN_RETARD,
  },
  [STATUT_ECHEANCIER.SOLDE]: {
    color:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
    border: "border-emerald-200 dark:border-emerald-800/30",
    label: STATUT_ECHEANCIER.SOLDE,
  },

  // Statuts des formations
  [STATUT_FORMATION.ABANDONNEE]: {
    color: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    border: "border-red-200 dark:border-red-800/30",
    label: STATUT_FORMATION.ABANDONNEE,
  },
  [STATUT_FORMATION.SUSPENDUE]: {
    color:
      "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
    border: "border-orange-200 dark:border-orange-800/30",
    label: STATUT_FORMATION.SUSPENDUE,
  },
  // Ajournée : le moniteur a explicitement retenu l'adhérent (recalé) plutôt
  // que de laisser la fin de formation automatique lui attribuer le niveau —
  // couleur distincte d'Abandonnée (rouge, départ adhérent) et de Suspendue
  // (orange, pause administrative/paiement).
  [STATUT_FORMATION.AJOURNEE]: {
    color:
      "bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-400",
    border: "border-pink-200 dark:border-pink-800/30",
    label: STATUT_FORMATION.AJOURNEE,
  },

  // Appréciation du moniteur (formations)
  Insuffisant: {
    color: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    border: "border-red-200 dark:border-red-800/30",
    label: "Insuffisant",
  },
  Satisfaisant: {
    color:
      "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400",
    border: "border-yellow-200 dark:border-yellow-800/30",
    label: "Satisfaisant",
  },
  Bien: {
    color: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
    border: "border-blue-200 dark:border-blue-800/30",
    label: "Bien",
  },
  Excellent: {
    color:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
    border: "border-emerald-200 dark:border-emerald-800/30",
    label: "Excellent",
  },

  // Statuts du matériel
  Neuf: {
    color:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
    border: "border-green-200 dark:border-green-800/30",
    label: "Neuf",
  },
  Bon: {
    color: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
    border: "border-blue-200 dark:border-blue-800/30",
    label: "Bon",
  },
  Usagé: {
    color:
      "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400",
    border: "border-yellow-200 dark:border-yellow-800/30",
    label: "Usagé",
  },
  "À réparer": {
    color:
      "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
    border: "border-orange-200 dark:border-orange-800/30",
    label: "À réparer",
  },
  "Hors service": {
    color: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    border: "border-red-200 dark:border-red-800/30",
    label: "Hors service",
  },
};

const StatusBadge = ({ status, showLabel = true }) => {
  // Si status est undefined ou null, afficher un badge par défaut
  if (!status) {
    return (
      <span className="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-full border border-gray-200 bg-gray-100 text-gray-600 dark:border-gray-600 dark:bg-gray-700/50 dark:text-gray-400">
        Inconnu
      </span>
    );
  }

  const config = statusConfig[status];

  // Si le statut n'est pas trouvé dans la config, afficher un badge par défaut
  if (!config) {
    return (
      <span className="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-full border border-gray-200 bg-gray-100 text-gray-600 dark:border-gray-600 dark:bg-gray-700/50 dark:text-gray-400">
        {status}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-full border ${config.color} ${config.border} transition-all hover:opacity-80`}
    >
      {showLabel && config.label}
    </span>
  );
};

export default StatusBadge;
